import React from "react";

const Fieldset = ({ children }) => {
  return <fieldset>{children}</fieldset>;
};

export default Fieldset;
